/* eslint-disable no-nested-ternary */
import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Pie } from '@ant-design/plots';
import H3Text from '@Uilib/h3Text';
import './style.scss';
import Helpers from '@Apis/helpers';
import { Spin } from 'antd';

/**
 *
 */
function MetricPieChart({
  data, loading,
}) {
  const config = {
    data: data?.list || [],
    angleField: 'value',
    colorField: 'type',
    color: ({ type }) => Helpers.getStatusColor(type)?.color,
    radius: 1,
    innerRadius: 0.78,
    label: null,
    statistic: false,
    autoFit: true,
    height: 130,
    legend: false,
    loading: data?.loading,
    tooltip: {
      customContent: (row, rowData) => (
        <div>
          <H3Text text={row?.replaceAll('_', ' ')} className="tooltip-value__title" />
          <H3Text text={`${MONEY(rowData?.[0]?.data?.value)}`} className="tooltip-value" />
          <H3Text text={`${rowData?.[0]?.data?.count} Orders`} className="tooltip-value-2" />
        </div>
      ),
    },
  };
  return (
    <div className="metric-pie-chart__loader">
      {loading && (
        <div className="widget-loader">
          <Spin />
        </div>
      )}
      <div className="metric-pie-chart">
        <H3Text text={data?.entity?.toProperCase()} className="metric-pie-chart__title" />
        <div className="metric-pie-chart__content">
          <div className="metric-pie-chart__pie">
            <Pie {...config} />
          </div>
          <div className="metric-pie-chart__legend">
            {
                data?.list?.map((item) => (
                  <Link to={item?.url} target="_blank">
                    <div className="legend__item">
                      <div className="legend__item-bullet" style={{ backgroundColor: Helpers.getStatusColor(item?.type)?.color }} />
                      <H3Text text={`${item?.type === 'SENT_FOR_APPROVAL' ? 'Not Approved' : item?.type?.replaceAll('_', ' ')?.toProperCase()} (${((item?.value / data?.value) * 100).toFixed(1)}%)`} className="legend__item-text" />
                    </div>
                  </Link>
                ))
            }
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
});

const mapDispatchToProps = (dispatch) => ({
});

MetricPieChart.propTypes = {
  user: PropTypes.any,
  data: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MetricPieChart));
